import styled from "styled-components";

export const BoxContentStyles = styled.div`
  flex-basis: 25%;

  @media (max-width: 950px) {
    flex-basis: 50%;
  }

  @media (max-width: 450px) {
    flex-basis: 100%;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  margin-block-end: 2.5rem;

  p {
    text-align: center;
  } 
`;